/*
 * @Author: shiguang
 * @Date: 2024-04-09 16:28:24
 * @LastEditors: shiguang
 * @LastEditTime: 2024-04-15 21:07:10
 * @Description:
 */
"use client";
import { useParams } from "next/navigation";
import { useTranslation } from "react-i18next";
import Breadcrumb from "@/app/[lang]/media/component/BreadCrumb/Index";

interface SupportCenterContentProps {
  videoUrl?: string;
  videoTitle?: string;
}
const SupportCenterContent = (props: SupportCenterContentProps) => {
  const { videoUrl, videoTitle } = props;
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <div>
      <div>
        <Breadcrumb
          dataSource={[
            { title: "HOME", href: `/${lang}` },
            { title: t("帮助中心"), href: `/${lang}/help` },
            { title: videoTitle },
          ]}
        />
      </div>
      <video controls className="h-[calc(100vh-32px)] w-[100%] bg-[#262626]">
        {!!videoUrl && <source src={videoUrl} />}
      </video>
    </div>
  );
};
export default SupportCenterContent;
